const CUSTOMER_TABLE_COLUMNS = [
    {name: "", mnemonic: "profile_picture", ui_class: "str", shrink: true},
    {name: "First Name", mnemonic: "first_name", ui_class: "str", shrink: true},
    {name: "Last Name", mnemonic: "last_name", ui_class: "str", shrink: true},
    {name: "Status", mnemonic: "is_active", ui_class: "str", shrink: true, header_align: "center", content_align: "center"},
    {name: "Email", mnemonic: "email", ui_class: "str", shrink: true},
    {name: "Role", mnemonic: "role_label", ui_class: "str"},
    {name: "Actions", mnemonic: "actions", ui_class: "str",header_align: "right", content_align: "right"}
];

const TA_ADMIN_TABLE_COLUMNS = [
    {name: "", mnemonic: "profile_picture", ui_class: "str", shrink: true},
    {name: "First Name", mnemonic: "first_name", ui_class: "str", shrink: true},
    {name: "Last Name", mnemonic: "last_name", ui_class: "str", shrink: true},
    {name: "Status", mnemonic: "is_active", ui_class: "str", shrink: true, header_align: "center", content_align: "center"},
    {name: "Email", mnemonic: "email", ui_class: "str", shrink: true},
    {name: "Company", mnemonic: "company", ui_class: "str", shrink: true},
    {name: "Role", mnemonic: "role_label", ui_class: "str"},
    {name: "Actions", mnemonic: "actions", ui_class: "str", header_align: "right", content_align: "right"}
];

export const variantUsersTableConfigMap = {
    "CustomerUsers": CUSTOMER_TABLE_COLUMNS,
    "AllUsers": TA_ADMIN_TABLE_COLUMNS
};